// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AFhzG","questions":"styles_questions__a0T9o","footer":"styles_footer__1La3t"};